import Query from "qpr-base/querybuilder/Query";
import defaultAttributes from "../defaultAttributes";
import { matchElementPeriodToRequestedPeriod } from "./matchElementPeriodToRequestedPeriod";
import { ICardElementWithChildren, IPeriod, IPeriodLevel } from "./model";

export const convertItemListToPeriod = async (
  valuelist: ICardElementWithChildren[],
  period: IPeriod,
  allPeriods: IPeriodLevel[]
) => {
  const list = Promise.all(
    valuelist.map((item) => {
      return matchElementPeriodToRequestedPeriod(
        item.id,
        period.name,
        item.periodlevelid || item.periodlevel || ""
      ).then((reqPeriod) => {
        if (!reqPeriod) {
          return {
            ...item,
            period,
            children: [],
          };
        }
        // return item;
        return Query(item.id)
          .attributes(...defaultAttributes(reqPeriod.name, allPeriods))
          .fetchValues<ICardElementWithChildren>()
          .then((itemlist) => {
            return {
              ...itemlist[0],
              period: reqPeriod,
              children: [],
            };
          });
      });
    })
  );
  return list;
};
